/*
 * Model for touchPoint label (intent summaries touchpoint)
 */

define(["backbone", "messaging/messenger"], function (Backbone, Messenger) {
  const TouchPointLabelModel = {};

  TouchPointLabelModel.touchPointLabel = Backbone.Model.extend({
    idAttribute: "id",
    defaults: {
      summary: "",
    },
    saveModel: function (options) {
      // Only save the model if the user is allowed to edit the Locale for the label.
      if (this._allowSave(options)) {
        // If the ID of the associated summary is unknown, then wait for it to save before saving this model
        if (!this.get("summaryId") && this.topicLabel) {
          this.topicLabel.once(
            "sync",
            function () {
              this._updateFromTopicLabel();
              this.constructor.__super__.saveModel.call(this, options);
            },
            this,
          );
        } else {
          this.constructor.__super__.saveModel.call(this, options);
        }
      } else if (options.success) {
        options.success(this);
      } else {
        Messenger.saveAttempted(true);
      }
    },
    setTopicLabel: function (topicLabel) {
      if (this.topicLabel) {
        this.topicLabel.off("change:summaryId", this._updateFromTopicLabel, this);
        this.topicLabel.off("change:intentId", this._updateFromTopicLabel, this);
        this.topicLabel.off("sync", this._updateFromTopicLabel, this);
      }
      this.topicLabel = topicLabel;
      this._updateFromTopicLabel();
      if (this.topicLabel) {
        this.topicLabel.on("change:summaryId", this._updateFromTopicLabel, this);
        this.topicLabel.on("change:intentId", this._updateFromTopicLabel, this);
        this.topicLabel.on("sync", this._updateFromTopicLabel, this);
      }
    },
    _allowSave: function () {
      // Do not allow the user to save a label for a touchpoint to which they do not have access
      if (
        !Messenger.reqres.request("can:edit:touchPoint", { touchPointId: this.get("touchpointId") })
      ) {
        return false;
      }
      // Only save the model if the user is allowed to edit the Locale for the label.
      if (!Messenger.reqres.request("can:edit:locale", { languageId: this.get("languageId") })) {
        return false;
      }
      // Do not bother saving new labels with empty values.  The server will ignore them, so save bandwidth.
      // If it is not new, then it must be saved so the server can remove the label if it wants to.
      if (this.isNew() && !this.get("summary")) {
        return false;
      }
      return this.constructor.__super__._allowSave.apply(this, arguments);
    },
    _updateFromTopicLabel: function () {
      //set intent summary id as summary id of topic label (foreign key)
      this.set(
        {
          summaryId: this.topicLabel.get("summaryId"),
          intentId: this.topicLabel.get("intentId"),
          languageId: this.topicLabel.get("languageId"),
        },
        { silent: true },
      );
      this.languageName = this.topicLabel.languageName;
    },
  });

  TouchPointLabelModel.touchPointLabels = Backbone.Collection.extend({
    model: TouchPointLabelModel.touchPointLabel,
    comparator: function (a, b) {
      return Backbone.textComparator(a, b, "_thisObject.languageName");
    },
    //Create new touchPoint label and add it to the collection
    addLabel: function (touchPointId, topicLabel) {
      const touchPointLabel = new TouchPointLabelModel.touchPointLabel({
        touchpointId: touchPointId,
      });
      touchPointLabel.setTopicLabel(topicLabel);
      this.add(touchPointLabel);
      return touchPointLabel;
    },
    backup: function () {
      this._backup();
      this.onSynced(function () {
        this._backup();
      }, this);
    },
    restore: function () {
      this.reset(this.clonedModels, {
        parse: true,
        silent: true,
      });
      this.dirty = this.wasDirty;
    },
    _backup: function () {
      this.wasDirty = this.dirty;
      this.clonedModels = [];
      this.forEach((model) => this.clonedModels.push(model.toJSON()));
    },
  });

  return TouchPointLabelModel;
});
